module.exports = __webpack_public_path__ + "img/Pin at home Icon - white.169861a1.svg";